import React from 'react';

interface InvoiceDownloaderActionButtonProps {
  type?: 'button' | 'submit';
  variant?: 'primary' | 'error';
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  className?: string;
}

export const InvoiceDownloaderActionButton: React.FC<
  InvoiceDownloaderActionButtonProps
> = ({
  type = 'button',
  variant = 'primary',
  disabled = false,
  loading = false,
  loadingText,
  onClick,
  children,
  className = '',
}) => {
  const baseClasses = 'max-w-md btn w-80';
  const variantClasses = variant === 'error' ? 'btn-error' : 'btn-primary';
  const combinedClasses =
    `${baseClasses} ${variantClasses} ${className}`.trim();

  return (
    <button
      type={type}
      className={combinedClasses}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? loadingText || 'Processing...' : children}
    </button>
  );
};
